<ph-dialog [open]="open" [attr.icon]="icon || null" [attr.heading]="heading" style="--ph-layer-dialog: 1240" (ph-close)="closed.emit(false)">
    <ph-stack>
        <span>{{ message }}</span>
        <ng-content></ng-content>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button *ngIf="!hideCancel" variant="secondary" mode="filled" type="button" (click)="closed.emit(false)">{{ cancelLabel }}</ph-button>
        <ph-button *ngIf="secondaryLabel" variant="secondary" mode="filled" type="button" (click)="secondary.emit()">{{ secondaryLabel }}</ph-button>
        <ph-button [variant]="destructive ? 'error' : 'primary'" mode="filled" type="button" (click)="closed.emit(true)">{{ confirmLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
